//
//
//
//
//
//
//
//

  import {mapMutations} from 'vuex'

  export default {
    props:['codeValue']
  }




// WEBPACK FOOTER //
// ./src/components/card/GoodCode.vue